import UserTable from "../components/usersTable/UserTable";
import UsersModal from "../utils/UserModal";
import classes from "./Users.module.css";
import React, { useState, useEffect } from "react";
import { MdEmail } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { useData } from "../context/DataContext";
import { Pagination, Modal } from "react-bootstrap";

const Users = () => {
  const {
    deleteLoading,
    tableData,
    setTableData,
    tableLoading,
    fetchAndUpdateName,
    deleteUserByEmail,
  } = useData();
  const [user, setUser] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [UsersPerPage] = useState(25);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchUsername, setSearchUsername] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastUser = currentPage * UsersPerPage;
  const indexOfFirstUser = indexOfLastUser - UsersPerPage;
  const currentUsers =
    searchEmail === "" && searchUsername === ""
      ? tableData.slice(indexOfFirstUser, indexOfLastUser)
      : filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  useEffect(() => {
    const filterUsers = () => {
      const filtered = tableData.filter((user) => {
        const { email, name } = user;
        const lowerCaseEmail = email ? email.toLowerCase() : "";
        const lowerCaseUsername = name ? name.toLowerCase() : "";

        return (
          (searchEmail === "" ||
            (lowerCaseEmail &&
              lowerCaseEmail.includes(searchEmail.toLowerCase()))) &&
          (searchUsername === "" ||
            (lowerCaseUsername &&
              lowerCaseUsername.includes(searchUsername.toLowerCase())))
        );
      });

      setFilteredUsers(filtered);
    };

    filterUsers();
  }, [tableData, searchEmail, searchUsername]);

  const handleUserUpdate = (selectedUser, updatedUsername) => {
    fetchAndUpdateName(selectedUser, updatedUsername);
  };

  const handleUserDelete = (selectedUser) => {
    setTableData((prev) => prev.filter((item) => item.id !== selectedUser.id));
    deleteUserByEmail(selectedUser.email, selectedUser);
  };

  const confirmDelete = () => {
    if (!userToDelete) return;
    handleUserDelete(userToDelete);
    setUserToDelete(null);
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleClear = () => {
    setSearchEmail("");
    setSearchUsername("");
  };

  const totalUsers =
    searchEmail === "" && searchUsername === "" ? tableData.length : filteredUsers.length;

  return (
    <div className="container p-3">
      <UsersModal
        user={user}
        show={show}
        setShow={setShow}
        onUpdate={handleUserUpdate}
        deleteLoading={deleteLoading}
      />
      <div>
        <h4>
          <strong className={classes.mainText}>Users</strong>
        </h4>
        <p className="small text-muted mb-2">
          User edits and deletes are logged to Firebase{" "}
          <strong>admin_edit_logs</strong>. Last edit details appear in the table
          when available.
        </p>
        <h5 className="my-2">Search</h5>
        <nav className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className={`input-group mb-3 ${classes.inp}`}>
            <span className="input-group-text">
              <FaUserAlt size={16} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search Full name"
              value={searchUsername}
              onChange={(e) => setSearchUsername(e.target.value)}
            />
          </div>

          <div className={`input-group mb-3 ${classes.inp}`}>
            <span className="input-group-text">
              <MdEmail size={16} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search Email"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
            />
          </div>

          <div>
            <button
              className={`btn mb-3 ${classes.btnCustom}`}
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </nav>
      </div>
      <div>
        {tableLoading && <div className="mt-2">Loading...</div>}
        {!tableLoading && (
          <UserTable
            data={currentUsers}
            setUser={setUser}
            setShow={setShow}
            onRequestDelete={setUserToDelete}
            deleteLoading={deleteLoading}
          />
        )}
      </div>
      {!tableLoading && (
        <div className="d-flex justify-content-center">
          <Pagination>
            {Array.from({ length: Math.ceil(totalUsers / UsersPerPage) }, (_, index) => (
              <Pagination.Item
                key={index}
                active={currentPage === index + 1}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      )}
      <Modal show={!!userToDelete} onHide={() => setUserToDelete(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete user{" "}
          <strong>{userToDelete?.name || userToDelete?.email}</strong>?
          <br />
          <span className="text-muted">
            This will remove the user account and related data. A full audit log
            entry will be saved.
          </span>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            disabled={deleteLoading}
            onClick={() => setUserToDelete(null)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            disabled={deleteLoading}
            onClick={confirmDelete}
          >
            Delete User
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Users;
